import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type TScrappingState = {
  data: [];
  perPage: number;
  currentPage: number;
  totalPage: number;
  searchTerm: string;
  loading: boolean;
  sortBy: string;
  sortColumn: string;
  rerender1: boolean;
  totalCount: number
};

const initialScrappingState: TScrappingState = {
  data: [],
  perPage: 10,
  currentPage: 1,
  totalPage: 1,
  searchTerm: "",
  loading: false,
  sortBy: "desc",
  sortColumn: "",
  rerender1: false,
   totalCount: 0
};

export const ScrappingSlice = createSlice({
  name: "Scrapping",
  initialState: initialScrappingState,
  reducers: {
    setScrapping: (state: TScrappingState, { payload }: PayloadAction<[]>) => {
      state.data = payload;
    },
    setPerPage: (
      state: TScrappingState,
      { payload }: PayloadAction<number>
    ) => {
      state.perPage = payload;
    },
     setTotalCount: (state:TScrappingState, {payload}: PayloadAction<number>) => {
                    state.totalCount = payload;
                },
    setCurrentPage: (
      state: TScrappingState,
      { payload }: PayloadAction<number>
    ) => {
      state.currentPage = payload;
    },
    setTotalPage: (
      state: TScrappingState,
      { payload }: PayloadAction<number>
    ) => {
      state.totalPage = payload;
    },
    setSearchTerm: (
      state: TScrappingState,
      { payload }: PayloadAction<string>
    ) => {
      state.searchTerm = payload;
    },
    setSortBy: (state: TScrappingState, { payload }: PayloadAction<string>) => {
      state.sortBy = payload;
    },
    setSortColumn: (
      state: TScrappingState,
      { payload }: PayloadAction<string>
    ) => {
      state.sortColumn = payload;
      state.sortBy = "desc";
    },
    setLoading: (
      state: TScrappingState,
      { payload }: PayloadAction<boolean>
    ) => {
      state.loading = payload;
    },
    setRerender: (
      state: TScrappingState,
      { payload }: PayloadAction<boolean>
    ) => {
      state.rerender1 = payload;
    },
  },
});

export const {
  setScrapping,
  setPerPage,
  setCurrentPage,
  setSortColumn,
  setSortBy,
  setTotalPage,
  setSearchTerm,
  setLoading,
  setRerender,
  setTotalCount
} = ScrappingSlice.actions;
export default ScrappingSlice.reducer;
